<template>
  <UiModal
    :show="showBetting"
    title="竞猜投注"
    iconType="quiz_1"
    bottom-bg
    @close="close"
  >
    <div class="amount">
      <div class="inner">
        <div class="left-box">
          <div class="icon-bg">
            <div class="name">
              <UiLabel shadow-color="#FFFFFF" text-color="#880000">
                {{ info.obj_name }}
              </UiLabel>
            </div>
            <div class="icon">
              <div
                class="head"
                :style="{
                  'background-image': `url(${info.obj_avatar})`,
                }"
              ></div>
              <div class="frame"></div>
            </div>
          </div>

          <div class="info">
            <UiLabel class="odd" shadow-color="#FFFFFF" text-color="#333333">
              赔率 {{ info.lossRate ? info.lossRate : '0' }}
            </UiLabel>
            <UiLabel class="rating" shadow-color="#FFFFFF" text-color="#333333">
              支持率 {{ Number(info.ratios * 100).toFixed(0) || 0 }} %
            </UiLabel>
          </div>
        </div>
        <div class="right-box">
          <div class="odds-rate">
            <div class="odds">
              <span class="title">赔率: </span>
              <span>{{ info.lossRate }}</span>
            </div>
            <div class="rate">
              <span class="title">支持率: </span>
              <span>{{Number(info.ratios * 100).toFixed(0) || 0 }}%</span>
            </div>
          </div>
          <div class="amount-get">
            <span class="title">竞猜正确后可获得:</span>
            <i></i>{{ amount_get }}
          </div>
          <div class="amount-predict">
            <div class="title">投注金额:</div>
            <ul class="amount-list">
              <li
                v-for="(amount, key) in amountList"
                :key="key"
                class="fixed-amount"
                :class="{ active: quizAmount === amount }"
                @click="chooseAmount(amount)"
              >
                <UiLabel>{{ amount }}</UiLabel>
              </li>
              <li
                class="other-amount"
                :class="{ active: quizAmount === inputAmount }"
                @click="handleOther(true)"
              >
                <UiLabel v-show="!otherAmount">其他金额</UiLabel>
                <input
                  ref="input"
                  v-show="otherAmount"
                  :value="inputAmount"
                  :class="{ 'active': quizAmount === inputAmount }"
                  type="number"
                  @input="handleAmountInput"
                  @blur="handleOther(false)"
                />
                <UiLabel v-show="otherAmount" class="input-display">{{ inputAmount }}</UiLabel>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div class="bottom">
      <div class="amount-surplus">
        <UiLabel shadow-color="#761114" text-color="#FFFFFF">余额</UiLabel>
        <i></i>
        <UiLabel shadow-color="#761114" text-color="#FFFFFF">
          {{ amount.quizRemainNum }}
        </UiLabel>
      </div>
      <UiButton class="betting-btn" colorType="red" @click="betting" hook>
        <div class="label-box">
          <div class="label-shadow">投注</div>
          <div class="label-text">投注</div>
        </div>
      </UiButton>
    </div>
  </UiModal>
</template>

<script setup>
import { ref, computed, watch, nextTick } from 'vue'
import { useAppStore } from '@/store'
import { useModal } from '@/composables/useModal'
import { usePrompt } from '@/composables/usePrompt'
import * as api from '@/service/index'
import UiModal from '@/components/ui-modal.vue'
import UiButton from '@/components/ui-button.vue'
import UiLabel from '@/components/ui-label'

const appStore = useAppStore()

const info = ref({})
const other = ref({})
const showBetting = ref(false)
const { close } = useModal('quiz-betting', showBetting, {
  onOpen(params) {
    if (params?.info) info.value = params.info
    if (params?.other) other.value = params.other
  },
  onClose() {
    quizAmount.value = amountList.value[2]
    inputAmount.value = 0
    info.value = {}
  }
})
const amountList = ref([10, 20, 50, 100, 500])
const quizAmount = ref(50)
const inputAmount = ref(0)
const otherAmount = ref(false)
const inRequest = ref(false)
// ratios: this.info.ratios * 100 || 0

const token = computed(() => appStore.token)
const amount = computed(() => appStore.amount)
const amount_get = computed(() => {
  return Math.round(info.value.lossRate * quizAmount.value)
})

// 模板 ref
const input = ref(null)
const { showPrompt } = usePrompt()

watch(inputAmount, (newAmount) => {
  console.log('newAmount', newAmount)
  // if (newAmount && newAmount > 0) {
    quizAmount.value = newAmount
  // } else {
  //   this.quizAmount = this.amountList[2]
  // }
})

function chooseAmount(amount) {
  if (quizAmount.value !== amount) {
    quizAmount.value = amount
  }
}
// 用 Vue @input 而非 native oninput: native 直接改 this.value 不 emit 新事件, Vue state 和 DOM 会脱钩
function handleAmountInput(e) {
  const raw = e.target.value
  let val = raw === '' ? 0 : Math.abs(Number(raw)) || 0
  if (val > 999999) val = 999999
  inputAmount.value = val
  // clamp 后如果 val 没变(比如从 9999999 → 999999 是首次),Vue 不会 re-render, DOM 需要手动同步
  if (String(val) !== raw) {
    e.target.value = val
  }
}
function handleOther(bool) {
  if (!inputAmount.value || inputAmount.value === 0) {
    // input为空时，才会控制显示隐藏
    otherAmount.value = bool

    if(bool) {
      quizAmount.value = inputAmount.value
    } else {
      quizAmount.value = amountList.value[2]
    }

    nextTick(() => {
      input.value.focus()
    })
  } else {
    // input不为空，为选中状态
    quizAmount.value = inputAmount.value
  }
}
async function betting() {
  if (Number(amount.value.quizRemainNum) >= Number(quizAmount.value)) {
    if (!inRequest.value) {
      inRequest.value = true

      let data = {
        // token: decodeURIComponent(this.token),
        quizId: Number(info.value.question_id),
        answerCode: info.value.answer_code,
        goldNum: Number(quizAmount.value)
      }
      if(!token.value) return;
      let response = await api.submitQuiz(token.value, data)
      if (response.status === 200) {
        if (response.data === true) {

          // 更新余额
          appStore.reqUserInfo(true)
          appStore.reqRedDotState()
          showPrompt('竞猜成功～')
          setTimeout(() => {
            close()
          }, 1500)
        } else {
          showPrompt(response.data)
        }
      } else {
        showPrompt(response.data)
      }

      inRequest.value = false
    }
  } else {
    showPrompt('您的竞猜币不够，请更改投注金额')
  }

  const trackEventFN = (eventName, properties) => {
    if (typeof tapdb === 'undefined') return
    tapdb.trackEvent(eventName, properties)
  }
  const commonProperties = {
    '#schedule_id': other.value.schedule_id,
    '#match_title': other.value.match_title,
    '#match_id': other.value.match_id,
    '#answer_name': info.value.answer_name,
    '#vote_name': info.value.obj_name
  }
  const eventTarget = {
    schedule: '赛事投票',
    live: '实时投票',
    rankpk: '排行PK',
    disusepk: '淘汰PK'
  }
  if (other.value.stype === 1) {
    // 战队预测
    trackEventFN(eventTarget[other.value.subType], commonProperties)
  } else {
    // console.log('shangbao')
    // live:'实时投票', rankpk:'排行PK', disusepk:'淘汰PK'
    trackEventFN(eventTarget[other.value.subType], {
      ...commonProperties,
      '#type': other.value.type
    })
  }
}
</script>

<style lang="scss" scoped>
@import "./betting";
</style>
